<template>
  <div v-if="showBanner" class="notification-element" :class="[extraCardClasses, 'promotion-notification-banner']" id="promotionNotificationBanner">
    <div class="promotion-notification" :class="{card: addCardClasses}">
      <div class="text" >
        <slot name="txtPromoNotification"></slot>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'BookedPromoNotificationBanner',
  data () {
    return {
      loading: false
    }
  },
  watch: {
    showBanner: {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:showBanner', newValue)
      }
    }
  },
  methods: {
    ...mapGetters('promotion/activePromotions', [
      'activePromotions'
    ])
  },
  computed: {
    showBanner: function () {
      if (!this.fromWrapper) {
        return false
      } else {
        const listActivePromotions = this.activePromotions()
        let targetPromotions = []
        if (isNaN(this.promoIdList)) {
          targetPromotions = this.promoIdList.split(',').map(n => parseInt(n, 10))
        } else {
          targetPromotions = [parseInt(this.promoIdList, 10)]
        }
        if (Array.isArray(listActivePromotions) && listActivePromotions.length > 0) {
          if (listActivePromotions.filter(promo => targetPromotions.includes(promo.promotionId)).length) {
            return true
          }
        }
        return false
      }
    },
    addCardClasses: function () {
      if (this.addCardClass) {
        return true
      }

      return false
    },
    extraCardClasses: function () {
      if (this.addCardClass) {
        return 'card-wrapper notification-card'
      }
      return ''
    }
  },
  props: {
    fromWrapper: {
      type: Boolean,
      default: false
    },
    addCardClass: {
      type: Boolean,
      default: false
    },
    promoIdList: {
      type: [String, Number],
      default: '0'
    }
  },
  mixins: [

  ]
}
</script>
